export default "/images/tik-img.png?db05189e0f0bbd2d999aabbfb3bcb70c";